const downloadFile = (file: Blob, fileName: string) => {
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName);
  const href = URL.createObjectURL(file);
  aElement.href = href;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
};

const getFileFromStorage = (url: string, fileName: string) => {
  fetch(`${window.__RUNTIME_CONFIG__.DOCUMENT_ROOT}${url}`, {
    method: 'get',
    mode: 'no-cors',
    referrerPolicy: 'no-referrer',
  })
    .then((res) => res.blob())
    .then((res) => {
      downloadFile(res, fileName);
    });
};

export default getFileFromStorage;
